import { useMemo } from "react";
import { computeCalendarMarks } from "../utils/streaks";

export default function useStreakDays({
  streakDays,
  activitiesByDay,
  activityDates,
  activities,
} = {}) {
  const derived = useMemo(() => {
    if (typeof streakDays === "number") return streakDays;

    if (activitiesByDay && typeof activitiesByDay === "object") {
      return computeCalendarMarks({
        activityDates: Object.entries(activitiesByDay || {})
          .filter(([, acts]) => Array.isArray(acts) && acts.length > 0)
          .map(([date]) => date),
      }).streakCount;
    }

    if (Array.isArray(activityDates)) {
      return computeCalendarMarks({ activityDates }).streakCount;
    }

    if (Array.isArray(activities)) {
      return computeCalendarMarks({ activities }).streakCount;
    }

    return 0;
  }, [streakDays, activitiesByDay, activityDates, activities]);

  return derived;
}